import React from 'react';
import { Card, CardBody, Row, Col, Badge } from 'reactstrap';
import IconButton from '~/components/IconButton';
import history from '~/services/history';

const ENV_LABEL = {
  test: { label: 'TESTE', color: '#6b7280' },
  live: { label: 'PRODUÇÃO', color: '#2544b1' },
};

const statusBadge = application => {
  if (application.revoked_at) {
    return { label: 'Revogada', bg: '#ef4444' };
  }
  if (!application.is_enabled) {
    return { label: 'Desativada', bg: '#9ca3af' };
  }
  return { label: 'Ativa', bg: '#10b981' };
};

export default function PartnerApplicationCard({ application, onDelete }) {
  const env = ENV_LABEL[application.environment] || ENV_LABEL.test;
  const status = statusBadge(application);

  return (
    <Card
      style={{
        boxShadow: '0rem 0.275rem 0.3rem 0.1rem rgba(0, 0, 0, 0.035)',
      }}
      className="card new-layout list-card grow-on-hover overflow-hidden"
      onClick={() => {
        history.push(`/aplicacoes-parceiras/${application.id}/editar`);
      }}
    >
      <CardBody className="card-body new-layout px-3 py-3">
        {/* desktop */}
        <Row className="w-100 h-100 mx-0 d-none d-lg-flex align-items-center">
          <Col xs={3} align="start">
            <div className="new-layout-card-list-strong-value text-truncate">
              {application.name}
            </div>
          </Col>
          <Col xs={3} align="start">
            <div
              className="new-layout-table-column-value text-truncate"
              style={{
                fontFamily:
                  '"JetBrains Mono", Menlo, Monaco, Consolas, monospace',
                fontSize: '12px',
              }}
            >
              {application.client_id}
            </div>
          </Col>
          <Col xs={1} align="start">
            <Badge
              style={{
                backgroundColor: env.color,
                color: '#fff',
                fontSize: '10px',
                letterSpacing: '0.05em',
                padding: '4px 8px',
              }}
            >
              {env.label}
            </Badge>
          </Col>
          <Col xs={1} align="start">
            <Badge
              style={{
                backgroundColor: status.bg,
                color: '#fff',
                fontSize: '10px',
                padding: '4px 8px',
              }}
            >
              {status.label}
            </Badge>
          </Col>
          <Col xs={2} align="start">
            <div className="new-layout-table-column-value">
              {application.formatted_last_used_at}
            </div>
          </Col>
          <Col xs={1} align="start">
            <div className="new-layout-table-column-value">
              {application.formatted_created_at}
            </div>
          </Col>
          <Col xs={1} align="center" className="h-100 px-2">
            <div
              className="h-100 d-flex flex-row align-items-center justify-content-around"
              onClick={e => e.stopPropagation()}
              role="button"
              tabIndex={0}
              aria-label="actions-wrapper"
            >
              <IconButton
                icon="las la-broadcast-tower"
                color="info"
                id={`webhooks-btn-${application.id}`}
                tip="Ver webhooks"
                forceTip
                click={e => {
                  e.stopPropagation();
                  history.push(
                    `/webhooks-parceiros?partner_application_id=${application.id}`
                  );
                }}
              />
              <IconButton
                icon="las la-pen"
                color="primary"
                id={`edit-btn-${application.id}`}
                tip="Editar"
                forceTip
                click={e => {
                  e.stopPropagation();
                  history.push(
                    `/aplicacoes-parceiras/${application.id}/editar`
                  );
                }}
              />
              <IconButton
                icon="las la-trash"
                color="danger"
                id={`delete-btn-${application.id}`}
                tip="Excluir"
                forceTip
                click={e => {
                  e.stopPropagation();
                  onDelete(application);
                }}
              />
            </div>
          </Col>
        </Row>

        {/* mobile */}
        <Row className="w-100 h-100 mx-0 d-lg-none">
          <Col className="px-0">
            <Row className="w-100 mx-0">
              <Col xs={9} align="start" className="px-0">
                <div className="new-layout-card-mobile font-weight-600">
                  {application.name}
                </div>
              </Col>
              <Col xs={3} className="px-0 d-flex justify-content-end">
                <div
                  onClick={e => e.stopPropagation()}
                  role="button"
                  tabIndex={0}
                  aria-label="actions"
                >
                  <IconButton
                    icon="las la-broadcast-tower"
                    color="info"
                    id={`webhooks-mobile-btn-${application.id}`}
                    tip="Ver webhooks"
                    click={e => {
                      e.stopPropagation();
                      history.push(
                        `/webhooks-parceiros?partner_application_id=${application.id}`
                      );
                    }}
                  />
                  <IconButton
                    icon="las la-trash"
                    color="danger"
                    id={`delete-mobile-btn-${application.id}`}
                    tip="Excluir"
                    click={e => {
                      e.stopPropagation();
                      onDelete(application);
                    }}
                  />
                </div>
              </Col>
            </Row>
            <hr />
            <Row className="w-100 mx-0 mb-2">
              <Badge
                className="mr-2"
                style={{
                  backgroundColor: env.color,
                  color: '#fff',
                  fontSize: '10px',
                  padding: '4px 8px',
                }}
              >
                {env.label}
              </Badge>
              <Badge
                style={{
                  backgroundColor: status.bg,
                  color: '#fff',
                  fontSize: '10px',
                  padding: '4px 8px',
                }}
              >
                {status.label}
              </Badge>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label font-weight-500 d-inline">
                    Client ID:
                  </div>
                  <div
                    className="new-layout-card-mobile value d-inline text-truncate ml-2"
                    style={{
                      fontFamily:
                        '"JetBrains Mono", Menlo, Monaco, Consolas, monospace',
                      fontSize: '11px',
                    }}
                  >
                    {application.client_id}
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label font-weight-500 d-inline">
                    Último uso:
                  </div>
                  <div className="new-layout-card-mobile value d-inline ml-2">
                    {application.formatted_last_used_at}
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label font-weight-500 d-inline">
                    Criada:
                  </div>
                  <div className="new-layout-card-mobile value d-inline ml-2">
                    {application.formatted_created_at}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
